import { Routes } from '@angular/router';
import { isNotAuthenticatedGuard } from './auth/guards/is-not-authenticated.guard';
import { isAuthenticatedGuard } from './auth/guards/is-authenticated.guard';
import { Error404PageComponent } from './shared/pages/error404-page/error404-page.component';
import { ExamplePageComponent } from './shared/pages/example-page/example-page.component';


export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [ isNotAuthenticatedGuard ],
    loadChildren: () => import('./auth/auth.routes').then( m => m.routes ),
  },
  {
    path: 'sadi',
    canActivate: [isAuthenticatedGuard],
    loadChildren: () => import('./sadi/sadi.routes').then( m => m.routes ),
    title: 'Sadi'
  },
  {
    path: '404',
    component: Error404PageComponent,
  },
  {
    path: 'example',
    component: ExamplePageComponent,
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: '',
    redirectTo: 'sadi',
    pathMatch: 'full',
  },
  {
    path: "**", // Captura todas las rutas no coincidentes
    redirectTo: '/404', // Redirige a la página 404 para rutas no encontradas
    pathMatch: "full"
  }
];
